import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  DeleteIcon,
  IconCoupon,
  MinusIcon,
  PlusIcon,
} from "../../../constant/icon";
import { DataContext } from "../../../contexts/DataContext";
import { useLanguage } from "../../../hooks/useLanguage";
import BaseButton from "../../button/BaseButton";
import ModalCoupon from "../actionBuyTicket/ModalCoupon";

function ItemTicketAddedMobile({ ticket, index, isHadOldOrder }) {
  const {
    onDeleteTicket,
    onInCreaseTicket,
    onDeCreaseTicket,
    setTicketUserBuy,
    ticketUserBuy,
  } = useContext(DataContext);
  const [priceTicket, setPriceTicket] = useState("");

  const disableButtonIncCease =
    ticket?.quantity >= ticket?.limitForUser ||
    ticket?.quantity >= ticket?.remainingQuantity;

  const handleInCreaseTicket = useCallback(() => {
    onInCreaseTicket(index);
  }, [index, onInCreaseTicket]);
  const handleDeCreaseTicket = useCallback(() => {
    onDeCreaseTicket(index);
  }, [index, onDeCreaseTicket]);
  const handleDeleteTicket = useCallback(() => {
    onDeleteTicket(index);
  }, [index, onDeleteTicket]);

  const calculateDiscount = (discountType, discountAmount, itemFee) => {
    let amount = 0;
    switch (discountType) {
      case "FIXED_AMOUNT":
        amount += discountAmount;
        break;
      case "PERCENTAGE":
        amount += (itemFee * discountAmount) / 100;
        break;
      default:
        break;
    }
    return itemFee - amount > 0 ? itemFee - amount : 0;
  };

  useEffect(() => {
    const priceTicketNew = ticket?.coupon?.couponCode
      ? calculateDiscount(
          ticket?.coupon?.discountType,
          ticket?.coupon?.discountAmount,
          +ticket?.price
        )* +ticket?.quantity
      : +ticket?.quantity * +ticket?.price;
    setPriceTicket(priceTicketNew.toFixed(2));
  }, [ticket, +ticket?.quantity * +ticket?.price]);

  const { nameWithLanguage, currentLanguage } = useLanguage();
  return (
    <div className="w-full ">
      <div className="flex flex-col w-full px-3 py-4 rounded-lg bg-secondary-200 gap-y-2">
        <div className="flex flex-row justify-between">
          <p className="font-bold text-purple-900 text-body-1">
            {ticket ? ticket[nameWithLanguage] : ""}
          </p>
          <div className="text-center">
            <p className="text-xs text-neutral-400 line-through">
              {ticket?.coupon?.couponCode &&
                (currentLanguage === "en"
                  ? `${+ticket?.quantity * +ticket?.price} SR`
                  : `SR ${+ticket?.quantity * +ticket?.price}`)}
            </p>
            <p className="font-bold text-neutral-800 text-title-2">
              {/* SR {+ticket?.quantity * +ticket?.price} */}
              {currentLanguage === "en"
                ? `${priceTicket} SR`
                : `SR ${priceTicket}`}
            </p>
          </div>
        </div>
        <div className="flex flex-row items-center justify-end">
          <div className="flex flex-row items-center justify-between w-1/2 ">
            <div className="flex flex-row items-center gap-x-3">
              <div>
                <BaseButton
                  onClick={handleDeCreaseTicket}
                  disable={isHadOldOrder ? true : ticket?.quantity <= 1}
                  className="rounded-lg"
                  sizeButton="small"
                  variant="outline"
                >
                  <MinusIcon />
                </BaseButton>
              </div>
              <p className="font-bold text-neutral-800 text-body-2">
                {ticket?.quantity}
              </p>
              <div>
                <BaseButton
                  disable={isHadOldOrder ? true : disableButtonIncCease}
                  onClick={handleInCreaseTicket}
                  className="rounded-lg"
                  sizeButton="small"
                  variant="outline"
                >
                  <PlusIcon />
                </BaseButton>
              </div>
            </div>
            <button
              disabled={isHadOldOrder}
              onClick={handleDeleteTicket}
              className={`${
                isHadOldOrder
                  ? "opacity-30 cursor-not-allowed"
                  : "active:ring-2 active:ring-primary-400 active:bg-none active:text-primary-200"
              } `}
            >
              <DeleteIcon />
            </button>
          </div>
        </div>

        <div className="flex gap-2 items-center border border-dashed border-[#9453FF] p-1 rounded">
          <IconCoupon />
          <p className="w-full text-body-3 text-[#9453FF]">
            {ticket?.coupon?.couponName ?? "-"}
          </p>
          <ModalCoupon
            ticket={ticket}
            setTicketUserBuy={setTicketUserBuy}
            ticketUserBuy={ticketUserBuy}
          />
        </div>
      </div>
    </div>
  );
}

const TicketsAddedMobile = ({ isHadOldOrder }) => {
  const { ticketUserBuy } = useContext(DataContext);
  return (
    <>
      {ticketUserBuy?.map((ticket, index) => {
        return (
          <ItemTicketAddedMobile
            isHadOldOrder={isHadOldOrder}
            ticket={ticket}
            key={`${ticket?.id}_mobile_${index}`}
            index={index}
          />
        );
      })}
    </>
  );
};

export default TicketsAddedMobile;
